import type { FC } from 'react';
import { Archive } from 'lucide-react';

import { InlineNavigationButton } from '@/shared/ui';
import { TEST_IDS } from '@/testIds';

interface PastPassesLinkProps {
  count: number;
  onClick: () => void;
}

const formatCount = (count: number): string =>
  `${count} ${count === 1 ? 'expired pass' : 'expired passes'}`;

export const PastPassesLink: FC<PastPassesLinkProps> = ({ count, onClick }) => {
  return (
    <InlineNavigationButton
      onClick={onClick}
      testId={TEST_IDS.pastPassesLink}
      before={<Archive size={16} aria-hidden="true" />}
    >
      View {formatCount(count)}
    </InlineNavigationButton>
  );
};
